import React from 'react';
import ReportTable from "../../../hoc/ReportTable/ReportTable";
import { ReportSectionHeader } from "../SectionHeader";
import { ReportSectionSubHeader } from "../SectionSubHeader";



const PrelimDamagesComponentNOPSLRA = (props) => (
    <div>
        <ReportSectionHeader>Estimate of Maximum Potentially Available Rule 10b-5 Aggregate Damages*</ReportSectionHeader>
        <ReportSectionSubHeader> &nbsp; &nbsp;*Damages are not capped for the PSLRA 90-Day Bounce-Back Provision</ReportSectionSubHeader>
        <ReportTable
            settings={[
                {
                    header: '', accessor: 'damageType',
                    map: {
                        APPLIED_INFLATION_RIBON: 'Applied Inflation Ribbon',
                        HOLDER_DAMAGES: 'Holder Investor Cohort (000s)',
                        TRADER_DAMAGES: 'Trader Investor Cohort (000s)',
                        COMPLETE_DAMAGES: 'Estimate of Maximum Potentially Available Rule 10b-5 Damages (000s)'
                    }
                },
                {
                    header: 'Max. Artificial Inflation',
                    accessor: 'maxDollarOfArtificialInflationPerShare',
                    dollarValue: true,
                    inThousands: true,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                },
            ]}
            data={props.aggregateDamagesNOPSLRA}
            name={"prelimDamagesNOPSLRA"}
            accumulator={"maxDollarOfArtificialInflationPerShare"}
            isNotApplicable={'Yes'}
            accumulatorDisplay={'Estimate of Maximum Potentially Available Rule 10b-5 Damages No PSLRA (000s)'}
        />
    </div>
);


export default PrelimDamagesComponentNOPSLRA;


// WEBPACK FOOTER //
// ./src/common/components/PrelimDamages/PrelimDamagesComponentNOPSLRA.js